import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Logo from '../Header/Logo';
import UtilService from '../../services/util';
import IntlMessages from '../../util/IntlMessages';
import OpenNotification from '../common/CommonButton/OpenNotification';
import { PWD_RESET } from '../../constants/apiConstant';
import InputBlock from '../common/InputBlock';
import { resetPasswordValidator } from '../Auth/SignupValidator';
import LoginRightSection from 'components/LoginRightSection';

class ResetPassword extends Component {
  constructor() {
    super();
    this.state = {
      errors: null,
      passwordChange: {
        confirmPassword: '',
        newPassword: '',
      },
    };
  }

  handleResetPassword = () => {
    let self = this;
    let data = {
      newPassword: this.state.passwordChange.newPassword,
      confirmPassword: this.state.passwordChange.confirmPassword,
    };
    let obj = {
      ...PWD_RESET,
      request: {
        token: this.props.match.params.token,
        newPassword: this.state.passwordChange.newPassword,
      },
    };
    const errors = resetPasswordValidator(data);
    if (!errors.isValid) {
      self.setState({ errors: errors.errors });
    } else {
      UtilService.callApi(obj, function (err, data) {
        if (err) {
          return OpenNotification({
            type: 'error',
            title: err.data.message,
          });
        }
        if (data && data.code === 'OK') {
          self.props.history.push('/signin');
          OpenNotification({
            type: 'success',
            title: 'Password is reset successfully.',
          });
        } else {
          OpenNotification({
            type: 'error',
            title: data.message,
          });
        }
      });
    }
  };

  handleOnChange = (key, value) => {
    let { passwordChange } = this.state;
    passwordChange[key] = value;
    let errors = null;
    if (this.state.errors) {
      errors = Object.assign('', this.state.errors);
      delete errors[key];
    }

    this.setState({ passwordChange, errors });
  };
  onBlur = (name, val) => {
    let self = this;
    let data = {
      [name]: val,
    };

    const errors = resetPasswordValidator(data);
    if (!errors.isValid) {
      self.setState({ errors: errors.errors });
    }
  };
  render() {
    const { passwordChange, errors } = this.state;
    return (
      <>
        {/* <div className="loginMainBlocks loginFormBlock">
          <div className="loginWrapper">
            <div className="loginLeft">
              <div className="pTrackLogo">
                <div className="text-center mb-20">
                  <img src={require("../../assets/img/logo-black.png")} />
                </div>
              </div>
              <div className="pForm">
                <div className="loginBlocksMain">
                  <div className="login-block">
                    <div className="page-til d-flex align-items-center">
                      <div>
                        <h3>
                          <IntlMessages id="app.resetpassword" />
                        </h3>
                      </div>
                    </div>
                    <div className="loginPage">
                      <div className="form-control">
                        <label htmlFor="newPassword" className="d-block">
                          <IntlMessages id="app.newpassword" />

                          {passwordChange.newPassword === "" ? (
                            <span className="required">*</span>
                          ) : (
                            <span
                              className="required"
                              style={{ color: "green" }}
                            >
                              *
                            </span>
                          )}
                        </label>
                        <input
                          className={
                            this.state.errors["newPassword"]
                              ? "input-error"
                              : ""
                          }
                          onChange={this.handleOnChange}
                          type="password"
                          id="newPassword"
                          name="newPassword"
                          value={this.state.newPassword}
                          onInput={(e) => {
                            let t = e.target.value;
                            let err = clone(this.state.errors);
                            let { passwordChange } = this.state;
                            if (t.length < 3) {
                              err["newPassword"] =
                                "Password must be 3 digit long.";
                            } else if (passwordChange.confirmPassword) {
                              passwordChange.confirmPassword = "";
                              err["confirmPassword"] = undefined;
                            } else {
                              err["newPassword"] = undefined;
                            }
                            this.setState({ errors: err, passwordChange });
                          }}
                        />
                        <span style={{ color: "red" }}>
                          {this.state.errors["newPassword"]}
                        </span>
                      </div>
                      <div className="form-control">
                        <label htmlFor="confirmPassword" className="d-block">
                          <IntlMessages id="app.confirmPassword" />

                          {passwordChange.confirmPassword === "" ? (
                            <span className="required">*</span>
                          ) : (
                            <span
                              className="required"
                              style={{ color: "green" }}
                            >
                              *
                            </span>
                          )}
                        </label>
                        <input
                          className={
                            this.state.errors["confirmPassword"]
                              ? "input-error"
                              : ""
                          }
                          onChange={this.handleOnChange}
                          type="password"
                          id="confirmPassword"
                          name="confirmPassword"
                          value={passwordChange.confirmPassword}
                          onInput={(e) => {
                            let t = e.target.value;
                            let err = clone(this.state.errors);
                            if (
                              !isEqual(
                                this.state.passwordChange.newPassword,
                                t
                              )
                            ) {
                              err["confirmPassword"] =
                                "Please make sure your passwords match.";
                            } else {
                              err["confirmPassword"] = undefined;
                            }
                            this.setState({ errors: err });
                          }}
                        />
                        <span style={{ color: "red" }}>
                          {this.state.errors["confirmPassword"]}
                        </span>
                      </div>
                      <div className="form-control">
                        <button
                          type="submit"
                          className="button primary-fill width-full"
                          onClick={this.handleResetPassword}
                        >
                          <IntlMessages id="app.resetpasswordbutton" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="adma-login-wrap">
          <div className="adma-login-container">
            <div className="loginpage">
              <div className="adma-login-main-content">
                <div className="adma-app-login-content">
                  <div className="adma-logo-content-bg">
                    <h1>
                      {/* <img src={require("../../assets/img/login/logo.png")} /> */}
                      <Logo />
                    </h1>
                    <h2 className="login-title">
                      Reset Password <span>to your account</span>
                    </h2>
                  </div>

                  {/* <form> */}
                  <InputBlock
                    info
                    onBlur={(e) => this.onBlur('newPassword', e.target.value)}
                    hasError={errors !== null && errors['newPassword'] ? errors['newPassword'] : false}
                    onChange={(e) => this.handleOnChange('newPassword', e.target.value)}
                    value={this.state.passwordChange.newPassword}
                    required
                    type="password"
                    label="New Password"
                    placeholder="New Password"
                  />
                  <InputBlock
                    hasError={errors !== null && errors['confirmPassword'] ? errors['confirmPassword'] : false}
                    onChange={(e) => this.handleOnChange('confirmPassword', e.target.value)}
                    value={this.state.passwordChange.confirmPassword}
                    onBlur={(e) => this.onBlur('confirmPassword', e.target.value)}
                    required
                    type="password"
                    label="Confirm Password"
                    placeholder="Confirm Password"
                  />

                  <div className="loginButton">
                    <button onClick={this.handleResetPassword} type="submit" className="commonButton">
                      <IntlMessages id="app.signup.Submit" />
                    </button>
                  </div>
                  {/* <hr class="login-shapret"></hr> */}
                  {/* </form> */}
                </div>
              </div>
              <LoginRightSection />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ResetPassword);
